import React, { createContext, useState, useContext, useEffect } from 'react';
import Cookies from 'js-cookie';
import { authService } from '../services/authService';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true); // Add loading state

  useEffect(() => {
    const checkAuth = async () => {
      const authToken = Cookies.get('authToken');
      if (authToken) {
        try {
          const response = await authService.validateToken(authToken);
          if (response.valid) {
            setIsAuthenticated(true);
            setUser(response.user);
          } else {
            // Token is invalid, clean up
            logout();
          }
        } catch (error) {
          console.error('Error validating token:', error);
          logout();
        }
      }
      setIsLoading(false);
    };
    
    checkAuth();
  }, []);

  const login = async (userid, password) => {
    try {
      const response = await authService.login(userid, password);
      
      if (response.token) {
        // Set authentication cookie (expires in 7 days)
        Cookies.set('authToken', response.token, { expires: 7 });
        
        setIsAuthenticated(true);
        setUser(response.user);
        localStorage.setItem('userId', response.user._id); // Add this line
        return true;
      }
      return false;
    } catch (error) {
      console.error('Error during login:', error);
      return false;
    }
  };

  const logout = () => {
    localStorage.removeItem('token');
    Cookies.remove('authToken');
    setIsAuthenticated(false);
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, user, login, logout, isLoading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
